var map = {
	"./symbol_0.png": 80118,
	"./symbol_1.png": 93407,
	"./symbol_2.png": 56548,
	"./symbol_3.png": 10445,
	"./symbol_4.png": 5586,
	"./symbol_5.png": 20411,
	"./symbol_6.png": 42080,
	"./symbol_7.png": 20201,
	"./symbol_8.png": 90686,
	"./symbol_9.png": 43175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8737;